import { AppEvent } from 'types/appEvent';
import { ProdStackInfo } from 'types/state';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextProdStackInfo = createReducer<
  undefined | null | ProdStackInfo,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'ProdStackManager__DataRecieved': {
      if (event.data.prodStackInfo) {
        return event.data.prodStackInfo;
      }

      return prev;
    }
    case 'ProdStackInfoResolved':
    case 'ProdStackManager__ProdStackInfoRecieved':
      return event.prodStackInfo;
    default:
      return prev;
  }
});
